import styled from '@emotion/styled'

export const BottomActionsContainer = styled.div({
  display: "flex",
  justifyContent: "flex-end",
  // margin: "0.625rem 0px 0.625rem auto",

  // '>div:first-child':{
  //     flex:1
  // }
});